import { useMemo } from "react";

import { useIntl } from "react-intl";

import ScrollUpBar from "@/components/scroll-up-bar/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import AgileShareUpNext, {
    AgileShareUpNextProps
} from "@/patterns/agile-overview-share-up-next/src";
import { PageTreeNodeData } from "@/patterns/agile-overview-sidenav/src";
import { useLocation } from "@/utils/location-provider";

function useAgileShareUpNextProps(
    pageTree: PageTreeNodeData[],
    title?: string | null,
    description?: string | null
): AgileShareUpNextProps {
    const intl = useIntl();
    const location = useLocation();
    const origin = "https://www.atlassian.com";
    const link = `${origin}${location.pathname}`;
    const defaultNextUrlSlug = useLocalizedHref("/agile");
    const defaultNextName = intl.formatMessage({
        id: "Agile.main.default-next-page-title",
        defaultMessage: "Agile"
    });

    return useMemo(
        () => ({
            title,
            description,
            link,
            defaultNextPage: {
                name: defaultNextName,
                urlSlug: defaultNextUrlSlug
            },
            pageTree
        }),
        [
            title,
            description,
            link,
            pageTree,
            defaultNextName,
            defaultNextUrlSlug
        ]
    );
}

export type ShareUpNextBarProps = {
    nodes: PageTreeNodeData[];
    title?: string | null;
    description?: string | null;
};

export const ShareUpNextBar = ({
    nodes,
    title,
    description
}: ShareUpNextBarProps) => {
    const agileShareUpNextProps = useAgileShareUpNextProps(
        nodes,
        title,
        description
    );

    return (
        <ScrollUpBar sticky anchor="bottom">
            <AgileShareUpNext {...agileShareUpNextProps} />
        </ScrollUpBar>
    );
};
